module.exports = __webpack_public_path__ + "static/media/snow.f273851d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/weather/snow.svg
// module id = 408
// module chunks = 0